export { default } from './browser/global.js'
export * from './browser/global.js'
